{
  "id": "campaign-083",
  "name": "Whispering Knoll",
  "seed": "campaign:83",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..~.L__L....",
    ".~~..__...x.",
    "..~..__.....",
    ",i...__...i.",
    ",*L..__..L*.",
    "..,.L__L....",
    ".,,i.__.i...",
    "..,..__...x.",
    "....h__h....",
    ".i.i.__.i.i.",
    ".....__.....",
    ".....__%%...",
    ".....__%....",
    "............",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 83,
  "biome": "cemetery",
  "par": {
    "reel": 6126,
    "push": 4826,
    "selfPropelled": 4536,
    "tractor": 3830,
    "zeroTurn": 3108,
    "fairway": 2318
  },
  "routeTries": {
    "par": {
      "reel": 6,
      "push": 6,
      "selfPropelled": 7,
      "tractor": 22,
      "zeroTurn": 13,
      "fairway": 13
    }
  }
}
